unable to read source [project]/packages/analitica/src/index.ts